import React from 'react';
import styles from './index.module.less';
import { Image, Space, Row, Col, Form } from 'antd';
import updateBinIcon from '@/images/update-bin-position.png';
import Trackbinposition from '@/images/Track-bin-position.png';
import Viewbinfreecontainers from '@/images/view-bin-free-containers.png';
import GenerateBinQRLabels from '@/images/Generate-Bin-QR-Labels.png';
import ProductionLabelGeneration from '@/images/wip-Label-Generation.png';
import GenerateEqpQRLabels from '@/images/Equipment-Label-Generation.png';
import AreaLabelGeneration from '@/images/Area-Label-Generation.png';
import approvalforLCtodispensematerial from '@/images/approval-for-LC-to-dispense-material.png';
import approvalforLCtosamplingmaterial from '@/images/Approval-for-LC-for-Sampling-materials.png';
import { getLoggedInUser } from 'utilities/helpers';
import { useLocation } from 'react-router-dom';

// import QCtruck from '../../images/3.svg';
// import CustomButton from '@/common/CustomButton';

const LandingPage = () => {
  const [form] = Form.useForm();
  const { user } = getLoggedInUser();
  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const cards = [
    {
      //title: 'Update Bin Position',
      url: '/updatebin',
      icon: updateBinIcon
    },
    {
      //title: 'Track Bin Position',
      url: '/trackbin',
      icon: Trackbinposition
    },
    {
      //title: 'View Bin Free Containers',
      url: '/free-containers',
      icon: Viewbinfreecontainers
    },
    {
      //title: 'Generate Bin QR Lables',
      url: '/generate-labels?type=prod_label',
      icon: GenerateBinQRLabels
    }
    // {
    //   //title: 'View Container History',
    //   url: '',
    //   icon: QCtruck
    // }
  ];

  const Prodcards = [
    {
      icon: ProductionLabelGeneration,
      url: `production-label-gen`
    },
    {
      //title: 'Generate Bin QR Lables',
      url: '/generate-labels?type=Equipment',
      icon: GenerateEqpQRLabels
    },
    {
      //title: 'Generate Bin QR Lables',
      url: '/generate-labels',
      icon: AreaLabelGeneration
    }
  ];

  const QAcards = [
    {
      icon: approvalforLCtodispensematerial,
      url: `dispense-material-list`
    },
    {
      icon: approvalforLCtosamplingmaterial,
      url: `batches-list?type=lc_sampling`
    }
  ];
  let cardsView =
    (user?.role == 'prod_user' || user?.role == 'prod_ebmr') &&
    searchParams.get('name') == 'prod_user'
      ? Prodcards
      : user?.role == 'qc_initiator'
      ? QAcards
      : cards;
  return (
    <>
      <Form form={form} layout="vertical">
        <Row gutter={24}>
          {cardsView.map((items, index) => {
            return (
              <Col
                xs={6}
                xl={4}
                md={6}
                sm={6}
                span={6}
                className={`${styles.cardbody1} mb-2`}
                key={index}
              >
                <Space direction="vertical">
                  <Image
                    src={items.icon}
                    preview={false}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = `${items.url}`;
                    }}
                    style={{ width: '100% !important' }}
                  />
                  <span>{items.title}</span>
                </Space>
                {/* <Card hoverable className={styles.cardbody}> */}
                {/* <Space direction="vertical">
                <Image
                  src={item.icon}
                  preview={false}
                  style={{ height: '100px', width: '50% !important' }}
                />
                <CustomButton
                  // className={styles.inwardbutton}
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = item.url;
                  }}
                >
                  {item.title}
                </CustomButton>
              </Space> */}
                {/* </Card> */}
              </Col>
            );
          })}
        </Row>
      </Form>
    </>
  );
};

export default LandingPage;
